<template>
  <div class="emap-flow-modal-addAssignee">
    <Modal v-model="visible" :title="$LocalH5('toolbar.addHandler')">
      <Form :model="form" ref="form" :label-width="80">
        <FormItem :label="$LocalH5('toolbar.node')" prop="taskId">
          <Select v-model="form.taskId" transfer :disabled="nodeList.length === 1" @on-change="nodeChange">
            <Option v-for="(item, index) in nodeList" :value="item.taskId" :key="index">{{ item.nodeName }}</Option>
          </Select>
        </FormItem>
        <FormItem :label="$LocalH5('toolbar.handler')" prop="assignees">
          <div class="add-assignee-item" :class="{'add-assignee-disabled': !form.taskId}" @click="customPick = !!form.taskId">
            <slot>
              <Tag v-for="(item, index) in defaultAssigneesObj" :name="item.userId" :key="index">{{item.userName}}</Tag>
              <Tag type="border" color="blue" v-for="(item, index) in assigneesObj" :name="item.userId" :key="index">{{item.userName}}</Tag>
            </slot>
          </div>
        </FormItem>
        <FormItem :label="$LocalH5('toolbar.handlerGroup')" prop="instAssignees" v-if="hasMultiInstance">
          <Select v-model="form.instAssignees" transfer multiple noDelDefault>
            <Option v-for="(item, index) in groups" :value="item.id" :key="index" :disabled="item.disabled">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button size="large" @click="visible = false">{{$LocalH5('buttonCancel')}}</Button>
        <Button type="primary" size="large"  @click="onConfirm">{{$LocalH5('buttonConfirm')}}</Button>
      </div>
    </Modal>
    <emap-flow-pick v-model="customPick" multiple :disabledOptions="form.defaultAssignees" :options="form.assignees" @on-confirm="emapflowPick"></emap-flow-pick>
  </div>
</template>

<script>
  import EmapFlowPick from '../emap-flow-pick.vue'
  import { getAddOrDelAssignee, queryMultiInstanceGroups } from '@/api/toolbar'

  export default {
    name: "add-asssignee",
    components: {
      EmapFlowPick
    },
    data() {
      return {
        visible: false,
        nodeList: [],
        form: {
          taskId: "",
          defaultAssignees: [],
          assignees: [],
          instAssignees: []
        },
        customPick: false,
        hasMultiInstance: false,
        defaultAssigneesObj: [],
        assigneesObj: [],
        groups: []
      }
    },
    props: {
      value: Boolean,
      taskid: String,
      defkey: String
    },
    watch: {
      value(val) {
        this.visible = val;
        if(val) this.initAddAssignee();
      },
      visible(val) {
        if(!val) this.$emit('input', false);
      },
    },
    methods: {
      initAddAssignee() {
        this.clearVariables()
        getAddOrDelAssignee({
          "taskId": this.taskid, 
          "defKey": this.defkey
        }).then(data => {
          if(data && data.items){
            this.nodeList = data.items
            if(this.nodeList.length === 1) {
              this.form.taskId = this.nodeList[0].taskId
              this.form.defaultAssignees = this.nodeList[0].assignees
              this.defaultAssigneesObj = this.nodeList[0].assigneesObj

              let keys = Object.keys(this.nodeList[0])
              if(keys.includes("candidateGroups")) {
                this.hasMultiInstance = true
                this.form.instAssignees = this.nodeList[0]["candidateGroups"].map(group => "group(" + group + ")")
                this.queryMultiInstanceGroups()
              }
            }
          }
        })
      },
      clearVariables() {
        this.hasMultiInstance = false
        this.nodeList = []
        this.form = {
          taskId: "",
          assignees: [],
          instAssignees: [],
          defaultAssignees: [],
          defaultInstAssignees: []
        }
        this.defaultAssigneesObj = []
        this.assigneesObj = []
        this.groups = []
      },
      queryMultiInstanceGroups() {
        queryMultiInstanceGroups({ defKey: this.defkey }).then(res => {
          if(res) {
            this.groups = res.map(opt => {
              opt.id = "group(" + opt.id + ")"
              if(this.form.instAssignees.includes(opt.id)) {
                opt.disabled = true
              }
              return opt
            })
          } else {
            this.$Message.error(this.$LocalH5('toolbar.userGroupTips'))
          }
        })
      },
      nodeChange(value) {
        if(!value) return
        let curNode = this.nodeList.filter(node => node.taskId === value)[0]
        this.form.defaultAssignees = curNode.assignees
        this.defaultAssigneesObj = curNode.assigneesObj
        this.form.assignees = []
        this.assigneesObj = []

        this.hasMultiInstance = false
        let keys = Object.keys(curNode)
        if(keys.includes("candidateGroups")) {
          this.hasMultiInstance = true
          this.form.instAssignees = curNode["candidateGroups"].map(group => "group(" + group + ")")
        }
      },
      emapflowPick(ids, options) {
        this.form.assignees = ids.filter(id => this.form.defaultAssignees.indexOf(id) === -1)
        this.assigneesObj = options.filter(item => {
          item.userId = item.ZGH
          item.userName = item.XM
          return this.form.defaultAssignees.indexOf(item.userId) === -1
        })
      },
      onConfirm() {
        if(!this.form.taskId) {
          this.$Message.warning(this.$LocalH5('toolbar.selectNode'))
          return
        }
        let tempArr = this.form.assignees
        if(this.hasMultiInstance) {
          this.groups.forEach(group => {
            if(!group.disabled && this.form.instAssignees.includes(group.id)) {
              tempArr.push(group.id)
            }
          })
        }
        if(!tempArr.length){
          this.$Message.warning(this.$LocalH5('toolbar.noChangeTips'))
          return
        }
        this.$emit('on-confirm', this.form.taskId, tempArr.join(','))
        this.visible = false
      }
    }
  };
</script>
<style scoped>
.add-assignee-item {
  border-radius: 4px;
  border: 1px solid #dcdee2;
  min-height: 30px;
  padding: 2px 8px;
  max-height: 200px;
  overflow: auto;
}
.add-assignee-disabled {
  background-color: #f3f3f3;
}
</style>